<template>
    <a-modal
        class="modal epic-default"
        :title="$t('cia.vehicle_checker.modal.titles.list')"
        :destroyOnClose="true"
        v-model:open="modal_visible"
        width="auto"
        :dialog-style="{ padding: '0 20px', maxWidth: '1536px' }"
    >
        <template #footer>
            <a-button data-cy="back-button" :type="'default'" key="back" @click="hideModal">
                {{ $t('cia.vehicle_checker.modal.buttons.close') }}
            </a-button>
        </template>
        <div class="form-container overflow-x-auto overflow-visible">
            <table-vehicle-portfolio-checker />
        </div>
    </a-modal>
</template>

<script>
import TableVehiclePortfolioChecker from '@/components/tables/VehiclePortfolioChecker.vue';

export default {
    components: {
        TableVehiclePortfolioChecker,
    },
    data() {
        return {
            processing: false,
            modal_visible: false,
        };
    },
    props: {
        section_type: {
            type: String,
            default: 'cover',
        },
        company_id: {
            type: String,
            default: '',
        },
        user_type: {
            type: String,
            default: 'admin',
        },
    },
    methods: {
        showModal() {
            this.modal_visible = true;
        },
        hideModal() {
            this.modal_visible = false;
        },
    },
};
</script>
